module.exports = __webpack_public_path__ + "img/ico_arw_up_on.e9c77fbe.svg";